import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { dateConvert } from "../../common/Helpers";
import { odoslanieDodavkyController } from "../../../controllers/odoslaniedodavky.controller";

// Import the Grid component.
import { Grid, GridColumn } from "@progress/kendo-react-grid";

class OdoslanieDodavky extends Component {
    state = { items: [], loading: true, skip: 0, take: 25, selectedDodavkaId: this.props.defaultSelectedDodavkaId };

    componentDidMount() {
        this.reloadGrid();
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.shouldReloadGrid && this.props.shouldReloadGrid !== nextProps.shouldReloadGrid) {
            this.reloadGrid();
        }
        return true;
    }

    reloadGrid = () => {
        this.setState({ loading: true });
        odoslanieDodavkyController
            .getOdoslanieDodavky()
            .then(ajaxData => {
                let data = JSON.parse(JSON.stringify(ajaxData), dateConvert);
                if (this.state.selectedDodavkaId) {
                    let selectedIndex = data.findIndex(x => x.iddodavka === this.state.selectedDodavkaId);
                    this.setState({
                        items: data,
                        loading: false,
                        skip: this.changePageBySelectedDodavka(selectedIndex)
                    });
                } else {
                    this.setState({
                        items: data,
                        loading: false
                    });
                }
                return data;
            })
            .then(() => {
                if (this.props.afterReload) {
                    this.props.afterReload();
                }
                if (this.state.selectedDodavkaId) {
                    this.scrollToSelected();
                }
            });
    };

    changePageBySelectedDodavka(selectedIndex) {
        return parseInt(selectedIndex / this.state.take, 10) * this.state.take;
    }

    pageChange = event => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    };

    scrollToSelected() {
        var divOdoslanieDodavky = document.getElementById("OdoslanieDodavky");
        if (divOdoslanieDodavky) {
            var container = divOdoslanieDodavky.getElementsByClassName("k-virtual-content");
            if (container) {
                var selectedElement = container[0].getElementsByClassName("k-state-selected");
                if (selectedElement && selectedElement.length > 0) selectedElement[0].scrollIntoView({ behavior: "smooth", block: "end" });
            }
        }
    }

    renderTable(items) {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="OdoslanieDodavky">
                <Grid
                    data={items
                        .slice(this.state.skip, this.state.take + this.state.skip)
                        .map(item => ({ ...item, selected: item.iddodavka === this.state.selectedDodavkaId }))}
                    skip={this.state.skip}
                    take={this.state.take}
                    total={items.length}
                    pageable={true}
                    onPageChange={this.pageChange}
                    selectedField="selected"
                    onRowClick={e => {
                        this.setState({ selectedDodavkaId: e.dataItem.iddodavka });
                        this.props.changeselectedDodavkaId(e.dataItem.iddodavka, e.dataItem.idexpedicia, e.dataItem.sposobDopravy);
                    }}>
                    <GridColumn field="idexpedicia2" title={localizationService.toLanguageString("OdoslanieDodavky.Grid.Exp", "Exp")} width="50px" />
                    <GridColumn field="iddodavka2" title={localizationService.toLanguageString("OdoslanieDodavky.Grid.ID", "ID")} width="50px" />
                    <GridColumn field="skratka" title={localizationService.toLanguageString("OdoslanieDodavky.Grid.Predajňa", "Predajňa")} />
                    <GridColumn field="cisloDodavky" title={localizationService.toLanguageString("OdoslanieDodavky.Grid.Dodávka", "Dodávka")} />
                    <GridColumn field="typTovaru" title={localizationService.toLanguageString("OdoslanieDodavky.Grid.Typ", "Typ")} width="50px" />
                    <GridColumn field="sposobDopravy" title={localizationService.toLanguageString("OdoslanieDodavky.Grid.Doprava", "Doprava")} />
                    <GridColumn field="pocetBalikov" title={localizationService.toLanguageString("OdoslanieDodavky.Grid.Balíkov", "Balíkov")} width="60px" />
                    <GridColumn field="pocetKs" title={localizationService.toLanguageString("OdoslanieDodavky.Grid.Ks", "Ks")} width="50px" />
                    <GridColumn
                        field="datum"
                        title={localizationService.toLanguageString("OdoslanieDodavky.Grid.Expedované", "Expedované")}
                        width="120px"
                        format="{0:EEEEEE d.M.yyyy H:mm}"
                    />
                    <GridColumn field="meno" title={localizationService.toLanguageString("OdoslanieDodavky.Grid.Expedoval", "Expedoval")} />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.state.items);

        return <div>{contents}</div>;
    }
}

export default OdoslanieDodavky;

registerForLocalization(OdoslanieDodavky);



// WEBPACK FOOTER //
// ./src/components/dialogs/OdeslaniTovaru/OdoslanieDodavky.js